<template>
    <div>
        <div class="input input-margin">
            <div class="icon"><img src="../../assets/image/phone.png"/></div>
            <input v-model="phone" autocomplete="off" type="tel" placeholder="请输入手机号码"/>
        </div>
        <div class="clearfix send-code">
            <div class="input fl">
                <div class="icon"><img src="../../assets/image/code.png" /></div>
                <input v-model="code" autocomplete="off" type="tel" placeholder="请输入验证码"/>
            </div>
            <div class="fr right-btn" :class="{'sending':sending}" @click="sendCode">
                {{sending ? time+'s后再获取' : '发送验证码'}}
            </div>
        </div>
        <div class="bottom-btns clearfix input-margin">
            <div class="fr">已有账号？<router-link to="/login" style="color: #47B3F6;">去登录</router-link></div>
        </div>
        <div class="large-btn" @click="nextStep">下一步</div>
    </div>
</template>
<script>
    import utils from '../../utils/index';
    import CookieUtils from '../../utils/CookieUtils';
    const { apis,$ } = utils;
    import Cookies from 'js-cookie'
    export default {
        name:'forget',
        data(){
            return {
                phone: '',
                code: '',
                sending: false,
                time: 60,
            };
        },
        methods:{
            sendCode(){
                if (this.sending) {
                    return false;
                }
                if(!this.phone){
                    this.$Modal.error({
                        title: '请输入手机号码',
                        width:260
                    });
                    return false;
                }
                this.sending = true;
                $.post(apis.forgetMsgSend, {
                    mobile: this.phone
                }).then(res => {
                    if(res.code === 0){
                        this.time = 60;
                        let timer = setInterval(() => {
                            this.time--;
                            if(this.time === 0){
                                clearInterval(timer);
                                this.sending = false;
                            }
                        },1000);
                    } else {
                        this.sending = false;
                        this.$Modal.error({
                            title: res.msg,
                            width:260
                        });
                    }
                });
            },
            nextStep(){
                let message = '';
                if(!this.phone){
                    message = '请输入手机号码';
                }else if(!this.code){
                    message = '请输入验证码';
                }
                if(message){
                    this.$Modal.error({
                        title: message,
                        width:260
                    });
                    return false;
                }
                $.post(apis.forgetCheck, {
                    mobile: this.phone,
                    code: this.code
                }).then(res => {
                    if(res.code === 0){
                        this.$router.push('/login/password');
                        CookieUtils.setCrossDomain('forget_token',res.token)

                    } else {
                        this.$Modal.error({
                            title: res.msg,
                            width:260
                        });
                    }
                });
            }
        },

    }
</script>
<style lang="scss" scoped>
    @import "./style/login.scss";
</style>
